import React, { useState, useEffect, useCallback } from 'react';
import { getMyLeaves,cancelLeave  } from '../../services/leavesAPIs';
import { ThemeProvider, useMediaQuery, Fab, Box } from '@mui/material';
import theme from '../../themes/theme';
import LeaveRequestForm from '../../components/Forms/LeaveRequestForm';
import MyLeavesCard from '../../components/cards/MyLeavesCard';
import { Visibility } from '@mui/icons-material'; // icon for the FAB
import Calendar from '../../assets/calendar.gif'; // Importing the calendar image

function LeaveRequestPage({leavesData, fetchData, IsEmployee=false}) {
  const[myLeaves, setMyLeaves] = useState(leavesData || []);
  const [cancellingIds, setCancellingIds] = useState(new Set()); 

  const [showLeavesCard, setShowLeavesCard] = useState(false);
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');


  const handleCanceling = async (leaveId) => {
  // Prevent double-clicks (optional extra safety)
  if (cancellingIds.has(leaveId)) return;

  setCancellingIds(prev => new Set([...prev, leaveId]));

  // ✅ Optimistically update: mark as cancelled in local state
  setMyLeaves(prev => 
    prev.map(leave => 
      leave.id === leaveId ? { ...leave, status: 'cancelled' } : leave
    )
  );

  try {
    await cancelLeave(leaveId);
    fetchData(); 
  } catch (error) {
    console.error(`Failed to cancel leave:`, error);
    alert(`Failed to cancel leave. Please try again.`);

    // ❌ Revert optimistic update on failure
    setMyLeaves(prev => 
      prev.map(leave => 
        leave.id === leaveId ? { ...leave, status: 'pending' } : leave
      )
    );
  } finally {
    setCancellingIds(prev => {
      const newSet = new Set(prev);
      newSet.delete(leaveId);
      return newSet;
    });
  }
};


  return (
    <ThemeProvider theme={theme}>
  {/* Layout for large screens */}
  {isLargeScreen ? (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <LeaveRequestForm onSubmitSuccess={fetchData} fetchData={fetchData} IsEmployee={IsEmployee} />
      <MyLeavesCard
        leaves={leavesData}
        onViewAll={() => console.log('Show all leaves')}
        onCancel={handleCanceling}
        cancellingIds={cancellingIds}
        itemsPerPage ={2}
      />
    </Box>
  ) : (
    // Layout for small screens
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <LeaveRequestForm onSubmitSuccess={fetchData} fetchData={fetchData} IsEmployee={IsEmployee} />

      {/* Floating button */}
      <Fab
        //aria-label="show-leaves"
        onClick={() => setShowLeavesCard(!showLeavesCard)}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1000,
          backgroundColor: 'var(--card-bg, white)',
          boxShadow: 3,
         }}
        >
        {/* <Visibility /> */}
        <img
          src={Calendar}
          alt="Calendar"
          style={{ width: '40px', height: '35px', borderRadius:'5px' }} // Adjust size as needed
        />
       
      </Fab>

      {/* Floating card */}
      {showLeavesCard && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 15,
            right: 105,
            width: '90%',
            maxWidth: 405,
            //maxHeight: '80vh',
            //overflowY: 'auto',
            zIndex: 1000,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: 'var(--card-bg, white)',
            p: 2,
          }}
        >
          <MyLeavesCard
            leaves={leavesData}
            onViewAll={() => console.log('Show all leaves')}
            onCancel={handleCanceling}
            cancellingIds={cancellingIds}
            itemsPerPage ={1}
          />
        </Box>
      )}
    </Box>
  )}
</ThemeProvider>

  );
}

export default LeaveRequestPage;